import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { S3_URL } from "../../const";
import moment from "moment";
import { numberFormat, convertCurrency } from "../../helper";

export default function ReceiptBill({ shopData, orderGroupData, title = "ໃບຮັບເງິນ (Receipt)" }) {
  const rawItems = orderGroupData?.offerprices ?? orderGroupData?.orders ?? [];
  const items = Array.isArray(rawItems) ? rawItems : (rawItems?.data ?? []);
  const totalAmount = items.reduce(
    (sum, it) => sum + (it?.amount ?? 0) * (it?.price ?? 0),
    0,
  );
  const currency = orderGroupData?.currency ?? "LAK";
  return (
    <Container style={{ maxWidth: 794, margin: "0 auto", padding: 20, fontSize: 12, lineHeight: 1.3 }}>
      <Row>
        <Col style={{ textAlign: "right" }}>
          <img src={S3_URL + shopData?.image} alt={shopData?.name} style={{ maxWidth: 80 }} />
        </Col>
        <Col style={{ minWidth: 350 }}>
          <h5 className="text-center">{shopData?.name ?? "-"}</h5>
          <p style={{ marginTop: -10 }} className="text-center">
            {shopData?.address?.village}, {shopData?.address?.district}, {shopData?.address?.province}
          </p>
          <p style={{ marginTop: -10 }} className="text-center">
            ເບີໂທ: {shopData?.phone ?? "-"} ເລກລະຫັດວິສາຫະກິດ​: {shopData?.businessNumber ?? "...."}
          </p>
          <h4 style={{ fontWeight: "bold", textAlign: "center" }}>
            <b>{title}</b>
          </h4>
        </Col>
        <Col></Col>
      </Row>
      <Row className="my-3">
        <Col>
          <p style={{ marginTop: -10 }}>
            <strong>ລູກຄ້າ:</strong> {orderGroupData?.userConfirm?.name ?? orderGroupData?.customerName ?? "-"}{" "}
            {orderGroupData?.userConfirm?.lastname ?? orderGroupData?.customerLastName ?? "-"}
          </p>
          <p style={{ marginTop: -10 }}>
            <strong>ທີ່ຢູ່:</strong> {orderGroupData?.userConfirm?.address?.village ?? orderGroupData?.village ?? "-"},{" "}
            {orderGroupData?.userConfirm?.address?.district ?? orderGroupData?.district ?? "-"},{" "}
            {orderGroupData?.userConfirm?.address?.province ?? orderGroupData?.province ?? "-"}
          </p>
          <p style={{ marginTop: -10 }}>
            <strong>ເບີໂທ:</strong> {orderGroupData?.userConfirm?.phone ?? orderGroupData?.phone ?? "-"}
          </p>
        </Col>
        <Col>
          <p style={{ marginTop: -10 }}>
            <strong>ເລກບິນ:</strong> {orderGroupData?.code ?? "-"}
          </p>
          <p style={{ marginTop: -10 }}>
            <strong>ວັນທີອອກບິນ:</strong> {moment(orderGroupData?.createdAt).format("DD/MM/YYYY")}
          </p>
          <p style={{ marginTop: -10 }}>
            <strong>ສະກຸນເງິນ:</strong> {currency}
          </p>
        </Col>
      </Row>
      <Table bordered responsive>
        <thead>
          <tr>
            <th style={{ textAlign: "center" }}>No</th>
            <th style={{ textAlign: "center" }}>ລາຍການ</th>
            <th style={{ textAlign: "center" }}>ຈຳນວນ</th>
            <th style={{ textAlign: "center" }}>ລາຄາ</th>
            <th style={{ textAlign: "center" }}>ລວມ</th>
          </tr>
        </thead>
        <tbody>
          {items?.map((it, idx) => (
            <tr key={it?.id ?? idx}>
              <td align="center">{idx + 1}</td>
              <td>{it?.productName ?? "-"}</td>
              <td align="center">{it?.amount ?? 0}</td>
              <td>
                <div className="d-flex justify-content-between">
                  <span>{convertCurrency(it?.currency ?? currency)}</span>
                  <span>{numberFormat(it?.price ?? 0)}</span>
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-between">
                  <span>{convertCurrency(it?.currency ?? currency)}</span>
                  <span>{numberFormat((it?.amount ?? 0) * (it?.price ?? 0))}</span>
                </div>
              </td>
            </tr>
          ))}
          <tr>
            <td colSpan={4} style={{ textAlign: "right", fontWeight: 600 }}>
              ລວມທັງໝົດ
            </td>
            <td>
              <div className="d-flex justify-content-between">
                <span>{convertCurrency(currency)}</span>
                <span>{numberFormat(totalAmount ?? 0)}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
      <Row className="mt-4">
        <Col className="d-flex justify-content-center flex-column align-items-center">
          <p style={{ marginTop: -10, fontSize: 12 }}>
            <strong>ຜູ້ຮັບເງິນ</strong>
          </p>
          <p style={{ marginTop: -10, fontSize: 12 }}>
            <strong>Payee's signature</strong>
          </p>
        </Col>
        <Col className="d-flex justify-content-center flex-column align-items-center">
          <p style={{ marginTop: -10, fontSize: 12 }}>
            <strong>ລູກຄ້າ</strong>
          </p>
          <p style={{ textAlign: "center", marginTop: -10, fontSize: 12 }}>
            <strong>Customer Signature</strong>
          </p>
        </Col>
      </Row>
    </Container>
  );
}
